import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=052b3d71&"
import script from "./Bottom.vue?vue&type=script&lang=ts&"
export * from "./Bottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports